import React, { useState, useEffect, useMemo } from 'react'
import axios from 'axios'

import Panel from '../ui/Panel'
import Btn from '../ui/Btn'
import VideoModal from '../ui/VideoModal'
import SponsorSelectVideo from './SponsorSelectVideo'
import {
  Notice,
  Confirm,
  Sheet,
  ClipGrid,
  ClipCard,
  EmptyState,
  SkeletonCards,
  IconPlus,
  IconTrash,
} from './media'
import './media.css'

/*
 * SPONSOR — the attached videos.
 *
 * Requests untouched:
 *   GET admin/sponsors/challengevideos/{id}
 *   GET admin/sponsors/challengevideosdelete/{id}/{VideoID}
 *
 * The grid of embedded players is gone. Every clip is a poster card and
 * playback happens in the one shared VideoModal — the same surface the picker
 * uses, so a clip looks and plays the same wherever it is met. The URLs come
 * from ui/videoSource, which walks the Wowza naming conventions instead of
 * assuming the .smil one exists.
 */

export default function SponsorVideos(props) {

  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState([])
  const [show, setShow] = useState(false)
  const [note, setNote] = useState(null)
  const [pendingDel, setPendingDel] = useState('')
  const [clipIndex, setClipIndex] = useState(-1)

  const handleClose = () => setShow(false)

  useEffect(() => {
    setIsLoading(true)
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const rows = Array.isArray(data) ? data.filter((row) => row && row.VideoID) : []

  const clips = useMemo(
    () => rows.map((row) => ({
      fileId: row.VideoID,
      name: row.VideoID,
      subtitle: 'Sponsor Video',
    })),
    [rows]
  )

  /* A reload that shortens the list must not strand the player on a clip that
     is no longer there. */
  useEffect(() => {
    if (clipIndex >= clips.length) setClipIndex(-1)
  }, [clips.length, clipIndex])

  const del = (VideoID) => {
    setPendingDel('')
    axios.get(process.env.REACT_APP_API_SERVER + 'admin/sponsors/challengevideosdelete/' + props.id + '/' + VideoID, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {

        if (res.data.err == 0) {
          loadData()
        } else {
          setNote({ kind: 'crit', text: 'Υπήρξε ένα πρόβλημα, παρακαλώ προσπαθήστε ξανά' })
        }


      }).catch(err => {
        setIsLoading(false)
        setNote({ kind: 'crit', text: 'Υπήρξε ένα πρόβλημα, παρακαλώ προσπαθήστε ξανά' })
      })
  }

  const loadData = () => {
    setIsLoading(true)
    axios.get(process.env.REACT_APP_API_SERVER + 'admin/sponsors/challengevideos/' + props.id, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {

        setData(res.data.results)
        setIsLoading(false)

      }).catch(err => {
        setIsLoading(false)
        setNote({ kind: 'crit', text: 'Δεν ήταν δυνατή η φόρτωση των βίντεο.' })
      })
  }

  return (
    <div className="md-stack">
      <Panel
        title="Sponsor Videos"
        subtitle={isLoading ? 'Φόρτωση...' : rows.length + ' βίντεο'}
        actions={
          <Btn variant="accent" onClick={() => setShow(true)}>
            {IconPlus}
            Προσθήκη Βίντεο
          </Btn>
        }
      >
        {note ? <Notice kind={note.kind} onClose={() => setNote(null)}>{note.text}</Notice> : null}

        {pendingDel ? (
          <Confirm
            text={<span><b>ΔΙΑΓΡΑΦΗ! Σίγουρα?</b> <span className="md-clip-id">{pendingDel}</span></span>}
            confirmLabel="Διαγραφή"
            cancelLabel="Άκυρο"
            onConfirm={() => del(pendingDel)}
            onCancel={() => setPendingDel('')}
          />
        ) : null}

        {isLoading ? <SkeletonCards count={3} /> : null}

        {!isLoading && rows.length === 0 ? (
          <EmptyState
            title="Κανένα βίντεο"
            hint="Δεν έχει συνδεθεί βίντεο με αυτόν τον sponsor."
            action={<Btn variant="accent" onClick={() => setShow(true)}>{IconPlus}Προσθήκη Βίντεο</Btn>}
          />
        ) : null}

        {!isLoading && rows.length > 0 ? (
          <ClipGrid>
            {rows.map((row, index) => (
              <ClipCard
                key={row.VideoID}
                fileId={row.VideoID}
                name={row.VideoID}
                subtitle="Sponsor Video"
                onPlay={() => setClipIndex(index)}
              >
                <Btn className="md-danger" onClick={() => setPendingDel(row.VideoID)} aria-label={'Διαγραφή ' + row.VideoID}>
                  {IconTrash}
                  Διαγραφή
                </Btn>
              </ClipCard>
            ))}
          </ClipGrid>
        ) : null}
      </Panel>

      {show ? (
        <Sheet title="Επιλογή Βίντεο" subtitle="Βιβλιοθήκη βίντεο" onClose={handleClose}>
          <SponsorSelectVideo ChallengeID={props.id} loadData={loadData} handleClose={handleClose} />
        </Sheet>
      ) : null}

      {clipIndex >= 0 && clips[clipIndex] ? (
        <VideoModal
          items={clips}
          index={clipIndex}
          title="Sponsor Videos"
          onIndex={setClipIndex}
          onClose={() => setClipIndex(-1)}
        />
      ) : null}
    </div>
  )
}
